import { RunOrderSimulationComponent } from "./component";

export const RunOrderSimulationContainer = () => {
  return <RunOrderSimulationComponent />;
};
